<div class="emailDialog">
   <sync-dialog
   [config]="
   {
   title: isValidPassword && showVerificationPrompt ? 'Verify email address' : !isValidPassword ? 'Enter your password' : 'Change email address', 
   isClosable: false, 
   actionButton: isValidPassword && showVerificationPrompt ? 'OK' : !isValidPassword ? 'Continue' : 'Verify', 
   cancelButton: isValidPassword && showVerificationPrompt ? '' : 'Cancel',
   onActionClick: isValidPassword && showVerificationPrompt ? onVerify : !isValidPassword ? verifyPassword : requestEmailChange,
   onCancelClick: closeEmailDialog,
   isButtonLoading: isActionButtonLoading,
   isActionButtonDisabled: invalidEmailError.length > 0 || disabledEmailField,
   }"
   [open]="showEmailDialog" 
   [isFullScreen]="false"
   [onClose]="closeEmailDialog">
   <div class="email-container" *ngIf="!showVerificationPrompt">
      <app-error *ngIf="errcode" [errcode]="errcode"></app-error>
      <div class="body-2">
         {{ !isValidPassword ? 'For your security, please enter your password to verify your identity before changing this setting.'
         : 'Enter the new email address you\'d like to use for your account. After updating, you\'ll use this email to sign in.' }}
      </div>
      <sync-text-field *ngIf="!isValidPassword" [inputType]="'password'" [label]="'Password'" [inputChange]="getPassword" [errorMessage]="incorrectPassError"></sync-text-field>
      <sync-text-field *ngIf="isValidPassword" [label]="'Email Address'" [value]="user.email" [inputChange]="getEmailAddress" [errorMessage]="invalidEmailError" [disabled]="disabledEmailField"></sync-text-field>
   </div>
   <div class="verification-prompt" *ngIf="showVerificationPrompt">
      <span class="body-1"> We've sent a verification email to</span>
      <span class="h6">{{newEmail}}</span>
      <span class="body-1">Please follow the instructions within the email to complete this process.</span>
   </div>
   </sync-dialog>
</div>